module.exports = __webpack_public_path__ + "static/Zbiornik_hydroforofy_ocynkowany2-2de5eab5df90644c3a913429eb8fb02e.png";